export const SET_APP_LOADING = 'SET_APP_LOADING';


export const SET_CLINICS = 'SET_CLINICS';
export const SET_CURRENT_CLINIC = 'SET_CURRENT_CLINIC';
export const GET_CLINICS = 'GET_CLINICS';

//POST APPOINTMENT
export const POST_APPOINTMENT_REQUEST = 'POST_APPOINTMENT_REQUEST';
export const POST_APPOINTMENT_SUCCESS = 'POST_APPOINTMENT_SUCCESS';
export const POST_APPOINTMENT_FAILURE = 'POST_APPOINTMENT_FAILURE';
//GET APPOINTMENT
export const GET_APPOINTMENT_REQUEST = 'GET_APPOINTMENT_REQUEST';
export const GET_APPOINTMENT_SUCCESS = 'GET_APPOINTMENT_SUCCESS';
export const GET_APPOINTMENT_FAILURE = 'GET_APPOINTMENT_FAILURE';

//GET APPOINTMENT_BY_ID
export const GET_APPOINTMENT_BY_ID_REQUEST = 'GET_APPOINTMENT_BY_ID_REQUEST';
export const GET_APPOINTMENT_BY_ID_SUCCESS = 'GET_APPOINTMENT_BY_ID_SUCCESS';
export const GET_APPOINTMENT_BY_ID_FAILURE = 'GET_APPOINTMENT_BY_ID_FAILURE';

//POST PATIENT
export const POST_PATIENT_REQUEST = 'POST_PATIENT_REQUEST';
export const POST_PATIENT_SUCCESS = 'POST_PATIENT_SUCCESS';
export const POST_PATIENT_FAILURE = 'POST_PATIENT_FAILURE';

//GET PATIENT
export const GET_PATIENT_REQUEST = 'GET_PATIENT_REQUEST';
export const GET_PATIENT_SUCCESS = 'GET_PATIENT_SUCCESS';
export const GET_PATIENT_FAILURE = 'GET_PATIENT_FAILURE';

//GET PATIENT_BY_ID
export const GET_PATIENT_BY_ID_REQUEST = 'GET_PATIENT_BY_ID_REQUEST';
export const GET_PATIENT_BY_ID_SUCCESS = 'GET_PATIENT_BY_ID_SUCCESS';
export const GET_PATIENT_BY_ID_FAILURE = 'GET_PATIENT_BY_ID_FAILURE';

//GET PATIENT_INFO_BY_ID
export const GET_PATIENTINFO_BY_ID_REQUEST = 'GET_PATIENTINFO_BY_ID_REQUEST';
export const GET_PATIENTINFO_BY_ID_SUCCESS = 'GET_PATIENTINFO_BY_ID_SUCCESS';
export const GET_PATIENTINFO_BY_ID_FAILURE = 'GET_PATIENTINFO_BY_ID_FAILURE';

//GET TAG BY PATIENT ID
export const GET_TAG_BY_PATIENT_ID_REQUEST = 'GET_TAG_BY_PATIENT_ID_REQUEST';
export const GET_TAG_BY_PATIENT_ID_SUCCESS = 'GET_TAG_BY_PATIENT_ID_SUCCESS';
export const GET_TAG_BY_PATIENT_ID_FAILURE = 'GET_TAG_BY_PATIENT_ID_FAILURE';

//GET ALL TAGS
export const GET_TAGS_REQUEST = 'GET_TAGS_REQUEST';
export const GET_TAGS_SUCCESS = 'GET_TAGS_SUCCESS';
export const GET_TAGS_FAILURE = 'GET_TAGS_FAILURE';

//GET AREA BY PATIENT ID
export const GET_AREA_BY_PATIENT_ID_REQUEST = 'GET_AREA_BY_PATIENT_ID_REQUEST';
export const GET_AREA_BY_PATIENT_ID_SUCCESS = 'GET_AREA_BY_PATIENT_ID_SUCCESS';
export const GET_AREA_BY_PATIENT_ID_FAILURE = 'GET_AREA_BY_PATIENT_ID_FAILURE';

//GET ALL AREAS
export const GET_AREAS_REQUEST = 'GET_AREAS_REQUEST';
export const GET_AREAS_SUCCESS = 'GET_AREAS_SUCCESS';
export const GET_AREAS_FAILURE = 'GET_AREAS_FAILURE';

//UPDATE STATUS
export const UPDATE_STATUS_REQUEST = 'UPDATE_PATIENT_REQUEST';
export const UPDATE_STATUS_SUCCESS = 'UPDATE_STATUS_SUCCESS';
export const UPDATE_STATUS_FAILURE = 'UPDATE_STATUS_FAILURE';

//POST MEDICAL RECORDS 
export const POST_MEDICALRECORD_REQUEST = 'POST_MEDICALRECORD_REQUEST';
export const POST_MEDICALRECORD_SUCCESS = 'POST_MEDICALRECORD_SUCCESS';
export const POST_MEDICALRECORD_FAILURE = 'POST_MEDICALRECORD_FAILURE';

//GET MEDICAL RECORDS BY PATIENT ID
export const GET_MEDICALRECORD_BY_PATIENTID_REQUEST = 'GET_MEDICALRECORD_BY_PATIENTID_REQUEST';
export const GET_MEDICALRECORD_BY_PATIENTID_SUCCESS = 'GET_MEDICALRECORD_BY_PATIENTID_SUCCESS';
export const GET_MEDICALRECORD_BY_PATIENTID_FAILURE = 'GET_MEDICALRECORD_BY_PATIENTID_FAILURE';

//GET MEDICAL RECORDS BY ID
export const GET_MEDICALRECORD_BY_ID_REQUEST = 'GET_MEDICALRECORD_BY_ID_REQUEST';
export const GET_MEDICALRECORD_BY_ID_SUCCESS = 'GET_MEDICALRECORD_BY_ID_SUCCESS';
export const GET_MEDICALRECORD_BY_ID_FAILURE = 'GET_MEDICALRECORD_BY_ID_FAILURE';

//DELETE MEDICAL RECORDS BY ID

export const DELETE_MEDICALRECORD_BY_ID_REQUEST = 'DELETE_MEDICALRECORD_BY_ID_REQUEST';
export const DELETE_MEDICALRECORD_BY_ID_SUCCESS = 'DELETE_MEDICALRECORD_BY_ID_SUCCESS';
export const DELETE_MEDICALRECORD_BY_ID_FAILURE = 'DELETE_MEDICALRECORD_BY_ID_FAILURE';

//GET AVAILABILITY

export const FETCH_AVAILABILITY_REQUEST = 'FETCH_AVAILABILITY_REQUEST';
export const FETCH_AVAILABILITY_SUCCESS = 'FETCH_AVAILABILITY_SUCCESS';
export const FETCH_AVAILABILITY_FAILURE = 'FETCH_AVAILABILITY_FAILURE';

//GET TEMPLATE BY CLINIC ID
export const GET_TEMPLATE_BY_CLINICID_REQUEST = 'GET_TEMPLATE_BY_CLINICID_REQUEST';
export const GET_TEMPLATE_BY_CLINICID_SUCCESS = 'GET_TEMPLATE_BY_CLINICID_SUCCESS';
export const GET_TEMPLATE_BY_CLINICID_FAILURE = 'GET_TEMPLATE_BY_CLINICID_FAILURE';

//POST TEMPLATE 
export const POST_TEMPLATE_REQUEST = 'POST_TEMPLATE_REQUEST';
export const POST_TEMPLATE_SUCCESS = 'POST_TEMPLATE_SUCCESS';
export const POST_TEMPLATE_FAILURE = 'POST_TEMPLATE_FAILURE';

//GET CUSTOM FIELDS
export const GET_CUSTOM_FIELDS_REQUEST = 'GET_CUSTOM_FIELDS_REQUEST';
export const GET_CUSTOM_FIELDS_SUCCESS = 'GET_CUSTOM_FIELDS_SUCCESS';
export const GET_CUSTOM_FIELDS_FAILURE = 'GET_CUSTOM_FIELDS_FAILURE';

//POST CUSTOM FIELDS
export const POST_CUSTOM_FIELDS_REQUEST = 'POST_CUSTOM_FIELDS_REQUEST';
export const POST_CUSTOM_FIELDS_SUCCESS = 'POST_CUSTOM_FIELDS_SUCCESS';
export const POST_CUSTOM_FIELDS_FAILURE = 'POST_CUSTOM_FIELDS_FAILURE';

//POST FOLLOWUP 
export const POST_FOLLOWUP_REQUEST = 'POST_FOLLOWUP_REQUEST';
export const POST_FOLLOWUP_SUCCESS = 'POST_FOLLOWUP_SUCCESS';
export const POST_FOLLOWUP_FAILURE = 'POST_FOLLOWUP_FAILURE';

//GET FOLLOW-UPS BY PATIENT ID 
export const GET_FOLLOWUP_BY_PATIENTID_REQUEST = 'GET_FOLLOWUP_BY_PATIENTID_REQUEST';
export const GET_FOLLOWUP_BY_PATIENTID_SUCCESS = 'GET_FOLLOWUP_BY_PATIENTID_SUCCESS';
export const GET_FOLLOWUP_BY_PATIENTID_FAILURE = 'GET_FOLLOWUP_BY_PATIENTID_FAILURE';

//GET TREATMENT BY PATIENT ID
export const GET_TREATMENT_BY_PATIENTID_REQUEST = 'GET_TREATMENT_BY_PATIENTID_REQUEST';
export const GET_TREATMENT_BY_PATIENTID_SUCCESS = 'GET_TREATMENT_BY_PATIENTID_SUCCESS';
export const GET_TREATMENT_BY_PATIENTID_FAILURE = 'GET_TREATMENT_BY_PATIENTID_FAILURE';

//GET BILLINGS BY PATIENT ID
export const GET_BILLINGS_BY_PATIENTID_REQUEST = 'GET_BILLINGS_BY_PATIENTID_REQUEST';
export const GET_BILLINGS_BY_PATIENTID_SUCCESS = 'GET_BILLINGS_BY_PATIENTID_SUCCESS';
export const GET_BILLINGS_BY_PATIENTID_FAILURE = 'GET_BILLINGS_BY_PATIENTID_FAILURE';

//POST MESSAGE
export const POST_MESSAGE_REQUEST = 'POST_MESSAGE_REQUEST';
export const POST_MESSAGE_SUCCESS = 'POST_MESSAGE_SUCCESS';
export const POST_MESSAGE_FAILURE = 'POST_MESSAGE_FAILURE';

//GET MESSAGE BY PATIENT ID
export const GET_MESSAGE_BY_PATIENTID_REQUEST = 'GET_MESSAGE_BY_PATIENTID_REQUEST';
export const GET_MESSAGE_BY_PATIENTID_SUCCESS = 'GET_MESSAGE_BY_PATIENTID_SUCCESS';
export const GET_MESSAGE_BY_PATIENTID_FAILURE = 'GET_MESSAGE_BY_PATIENTID_FAILURE';

//DELETE MESSAGE BY ID
export const DELETE_MESSAGE_BY_ID_REQUEST = 'DELETE_MESSAGE_BY_ID_REQUEST';
export const DELETE_MESSAGE_BY_ID_SUCCESS = 'DELETE_MESSAGE_BY_ID_SUCCESS';
export const DELETE_MESSAGE_BY_ID_FAILURE = 'DELETE_MESSAGE_BY_ID_FAILURE';

//POST REPORT

//GET REPORT BY PATIENT ID
export const GET_REPORT_BY_PATIENTID_REQUEST = 'REPORT_BY_PATIENTID_REQUEST';
export const GET_REPORT_BY_PATIENTID_SUCCESS = 'REPORT_BY_PATIENTID_SUCCESS';
export const GET_REPORT_BY_PATIENTID_FAILURE = 'REPORT_BY_PATIENTID_FAILURE';

//VIEW REPORT BY ID
export const GET_VIEWREPORT_BY_ID_REQUEST = 'GET_VIEWREPORT_BY_ID_REQUEST';
export const GET_VIEWREPORT_BY_ID_SUCCESS = 'GET_VIEWREPORT_BY_ID_SUCCESS';
export const GET_VIEWREPORT_BY_ID_FAILURE = 'GET_VIEWREPORT_BY_ID_FAILURE';

//DOWNLOAD REPORT BY ID
export const GET_DOWNLOADREPORT_BY_ID_REQUEST = 'GET_DOWNLOADREPORT_BY_ID_REQUEST';
export const GET_DOWNLOADREPORT_BY_ID_SUCCESS = 'GET_DOWNLOADREPORT_BY_ID_SUCCESS';
export const GET_DOWNLOADREPORT_BY_ID_FAILURE = 'GET_DOWNLOADREPORT_BY_ID_FAILURE';

//POST DOCTOR PROFILE 
export const POST_DOCTORPROFILE_REQUEST = 'POST_DOCTORPROFILE_REQUEST';
export const POST_DOCTORPROFILE_SUCCESS = 'POST_DOCTORPROFILE_SUCCESS';
export const POST_DOCTORPROFILE_FAILURE = 'POST_DOCTORPROFILE_FAILURE';

//GET DOCTOR PROFILE BY ID
export const GET_DOCTORPROFILE_BY_ID_REQUEST = 'GET_DOCTORPROFILE_BY_ID_REQUEST';
export const GET_DOCTORPROFILE_BY_ID_SUCCESS = 'GET_DOCTORPROFILE_BY_ID_SUCCESS';
export const GET_DOCTORPROFILE_BY_ID_FAILURE = 'GET_DOCTORPROFILE_BY_ID_FAILURE';

//POST CLINIC PROFILE 
export const POST_CLINICPROFILE_REQUEST = 'POST_CLINICPROFILE_REQUEST';
export const POST_CLINICPROFILE_SUCCESS = 'POST_CLINICPROFILE_SUCCESS';
export const POST_CLINICPROFILE_FAILURE = 'POST_CLINICPROFILE_FAILURE';

//GET CLINIC PROFILE BY ID
export const GET_CLINICPROFILE_BY_ID_REQUEST = 'FETCH_CLINIC_PROFILE_FORCE_REQUEST';
export const GET_CLINICPROFILE_BY_ID_SUCCESS = 'FETCH_CLINIC_PROFILE_FORCE_SUCCESS';
export const GET_CLINICPROFILE_BY_ID_FAILURE = 'FETCH_CLINIC_PROFILE_FORCE_FAILURE';

//UPDATE PATIENT BY ID
export const UPDATE_PATIENT_BY_ID_REQUEST = 'UPDATE_PATIENT_BY_ID_REQUEST';
export const UPDATE_PATIENT_BY_ID_SUCCESS = 'UPDATE_PATIENT_BY_ID_SUCCESS';
export const UPDATE_PATIENT_BY_ID_FAILURE = 'UPDATE_PATIENT_BY_ID_FAILURE';

//UPDATE PATIENT INFO BY ID
export const UPDATE_PATIENTINFO_BY_ID_REQUEST = 'UPDATE_PATIENTINFO_BY_ID_REQUEST';
export const UPDATE_PATIENTINFO_BY_ID_SUCCESS = 'UPDATE_PATIENTINFO_BY_ID_SUCCESS';
export const UPDATE_PATIENTINFO_BY_ID_FAILURE = 'UPDATE_PATIENTINFO_BY_ID_FAILURE';

//UPDATE AREA BY ID
export const UPDATE_AREA_BY_ID_REQUEST = 'UPDATE_AREA_BY_ID_REQUEST';
export const UPDATE_AREA_BY_ID_SUCCESS = 'UPDATE_AREA_BY_ID_SUCCESS';
export const UPDATE_AREA_BY_ID_FAILURE = 'UPDATE_AREA_BY_ID_FAILURE';

//UPDATE TAG BY ID
export const UPDATE_TAG_BY_ID_REQUEST = 'UPDATE_TAG_BY_ID_REQUEST';
export const UPDATE_TAG_BY_ID_SUCCESS = 'UPDATE_TAG_BY_ID_SUCCESS';
export const UPDATE_TAG_BY_ID_FAILURE = 'UPDATE_TAG_BY_ID_FAILURE';

//POST AREA 
export const POST_AREA_REQUEST = 'POST_AREA_REQUEST';
export const POST_AREA_SUCCESS = 'POST_AREA_SUCCESS';
export const POST_AREA_FAILURE = 'POST_AREA_FAILURE';

//POST TAG
export const POST_TAG_REQUEST = 'POST_TAG_REQUEST';
export const POST_TAG_SUCCESS = 'POST_TAG_SUCCESS';
export const POST_TAG_FAILURE = 'POST_TAG_FAILURE';

//POST PATIENT INFO
export const POST_PATIENTINFO_REQUEST = 'POST_PATIENTINFO_REQUEST';
export const POST_PATIENTINFO_SUCCESS = 'POST_PATIENTINFO_SUCCESS';
export const POST_PATIENTINFO_FAILURE = 'POST_PATIENTINFO_FAILURE';

//POST TREATMENT
export const POST_TREATMENT_REQUEST = 'POST_TREATMENT_REQUEST';
export const POST_TREATMENT_SUCCESS = 'POST_TREATMENT_SUCCESS';
export const POST_TREATMENT_FAILURE = 'POST_TREATMENT_FAILURE';

//POST BILLING
export const POST_BILLING_REQUEST = 'POST_BILLING_REQUEST';
export const POST_BILLING_SUCCESS = 'POST_BILLING_SUCCESS';
export const POST_BILLING_FAILURE = 'POST_BILLING_FAILURE';

//POST UPLOAD
export const POST_UPLOAD_REQUEST = 'POST_UPLOAD_REQUEST';
export const POST_UPLOAD_SUCCESS = 'POST_UPLOAD_SUCCESS';
export const POST_UPLOAD_FAILURE = 'POST_UPLOAD_FAILURE';

//POST UPLOADLOGO
export const POST_UPLOADLOGO_REQUEST = 'POST_UPLOADLOGO_REQUEST';
export const POST_UPLOADLOGO_SUCCESS = 'POST_UPLOADLOGO_SUCCESS';
export const POST_UPLOADLOGO_FAILURE = 'POST_UPLOADLOGO_FAILURE';

//POST UPLOADPIC
export const POST_PROFILEPIC_REQUEST = 'POST_PROFILEPIC_REQUEST';
export const POST_PROFILEPIC_SUCCESS = 'POST_PROFILEPIC_SUCCESS';
export const POST_PROFILEPIC_FAILURE = 'POST_PROFILEPIC_FAILURE';

//POST STAFF
export const POST_STAFF_REQUEST = 'POST_STAFF_REQUEST';
export const POST_STAFF_SUCCESS = 'POST_STAFF_SUCCESS';
export const POST_STAFF_FAILURE = 'POST_STAFF_FAILURE';

//GET STAFF
export const GET_STAFF_REQUEST = 'GET_STAFF_REQUEST';
export const GET_STAFF_SUCCESS = 'GET_STAFF_SUCCESS';
export const GET_STAFF_FAILURE = 'GET_STAFF_FAILURE';

//POST CLINIC
export const POST_CLINIC_REQUEST = 'POST_CLINIC_REQUEST';
export const POST_CLINIC_SUCCESS = 'POST_CLINIC_SUCCESS';
export const POST_CLINIC_FAILURE = 'POST_CLINIC_FAILURE';

//GET CLINIC
export const GET_CLINIC_REQUEST = 'GET_CLINIC_REQUEST';
export const GET_CLINIC_SUCCESS = 'GET_CLINIC_SUCCESS';
export const GET_CLINIC_FAILURE = 'GET_CLINIC_FAILURE';

//UPDATE CLINIC BY ID
export const UPDATE_CLINIC_BY_ID_REQUEST = 'UPDATE_CLINIC_BY_ID_REQUEST';
export const UPDATE_CLINIC_BY_ID_SUCCESS = 'UPDATE_CLINIC_BY_ID_SUCCESS';
export const UPDATE_CLINIC_BY_ID_FAILURE = 'UPDATE_CLINIC_BY_ID_FAILURE';

//GET CLINIC BY ID

export const GET_CLINIC_BY_ID_REQUEST = 'GET_CLINIC_BY_ID_REQUEST';
export const GET_CLINIC_BY_ID_SUCCESS = 'GET_CLINIC_BY_ID_SUCCESS';
export const GET_CLINIC_BY_ID_FAILURE = 'GET_CLINIC_BY_ID_FAILURE';

//GET HISTORY BY PATIENT ID
export const GET_PATIENT_HISTORY_BY_PATIENT_ID_REQUEST = 'GET_PATIENT_HISTORY_BY_PATIENT_ID_REQUEST';
export const GET_PATIENT_HISTORY_BY_PATIENT_ID_SUCCESS = 'GET_PATIENT_HISTORY_BY_PATIENT_ID_SUCCESS';
export const GET_PATIENT_HISTORY_BY_PATIENT_ID_FAILURE = 'GET_PATIENT_HISTORY_BY_PATIENT_ID_FAILURE';

//POST TASK
export const POST_TASK_REQUEST = 'POST_TASK_REQUEST';
export const POST_TASK_SUCCESS = 'POST_TASK_SUCCESS';
export const POST_TASK_FAILURE = 'POST_TASK_FAILURE';

//GET TASK
export const GET_TASK_REQUEST = 'GET_TASK_REQUEST';
export const GET_TASK_SUCCESS = 'GET_TASK_SUCCESS';
export const GET_TASK_FAILURE = 'GET_TASK_FAILURE';

//POST TASK COMMENT
export const POST_TASKCOMMENT_BY_TASKID_REQUEST = 'POST_TASKCOMMENT_BY_TASKID_REQUEST';
export const POST_TASKCOMMENT_BY_TASKID_SUCCESS = 'POST_TASKCOMMENT_BY_TASKID_SUCCESS';
export const POST_TASKCOMMENT_BY_TASKID_FAILURE = 'POST_TASKCOMMENT_BY_TASKID_FAILURE';

//GET BILLING
export const GET_BILLING_REQUEST = 'GET_BILLING_REQUEST';
export const GET_BILLING_SUCCESS = 'GET_BILLING_SUCCESS';
export const GET_BILLING_FAILURE = 'GET_BILLING_FAILURE';

export const GET_SUMMARY_REQUEST = 'GET_SUMMARY_REQUEST';
export const GET_SUMMARY_SUCCESS = 'GET_SUMMARY_SUCCESS';
export const GET_SUMMARY_FAILURE = 'GET_SUMMARY_FAILURE';

export const GET_GOOGLE_AUTH_URL_REQUEST = 'GET_GOOGLE_AUTH_URL_REQUEST';
export const GET_GOOGLE_AUTH_URL_SUCCESS = 'GET_GOOGLE_AUTH_URL_SUCCESS';
export const GET_GOOGLE_AUTH_URL_FAILURE = 'GET_GOOGLE_AUTH_URL_FAILURE';

//GET APPOINTMENT BY PATIENT ID
export const GET_APPOINTMENT_BY_PATIENTID_REQUEST = 'GET_APPOINTMENT_BY_PATIENTID_REQUEST';
export const GET_APPOINTMENT_BY_PATIENTID_SUCCESS = 'GET_APPOINTMENT_BY_PATIENTID_SUCCESS';
export const GET_APPOINTMENT_BY_PATIENTID_FAILURE = 'GET_APPOINTMENT_BY_PATIENTID_FAILURE';

//GET TREATMENT_BY_ID
export const GET_TREATMENT_BY_ID_REQUEST = 'GET_TREATMENT_BY_ID_REQUEST';
export const GET_TREATMENT_BY_ID_SUCCESS = 'GET_TREATMENT_BY_ID_SUCCESS';
export const GET_TREATMENT_BY_ID_FAILURE = 'GET_TREATMENT_BY_ID_FAILURE';

export const GET_SUMMARYSTAT_REQUEST = 'GET_SUMMARYSTAT_REQUEST';
export const GET_SUMMARYSTAT_SUCCESS = 'GET_SUMMARYSTAT_SUCCESS';
export const GET_SUMMARYSTAT_FAILURE = 'GET_SUMMARYSTAT_FAILURE';

export const GET_MONTHLYAPPOINTMENT_REQUEST = 'GET_MONTHLYAPPOINTMENT_REQUEST';
export const GET_MONTHLYAPPOINTMENT_SUCCESS = 'GET_MONTHLYAPPOINTMENT_SUCCESS';
export const GET_MONTHLYAPPOINTMENT_FAILURE = 'GET_MONTHLYAPPOINTMENT_FAILURE';

export const GET_TASKOVERVIEW_REQUEST = 'GET_TASKOVERVIEW_REQUEST';
export const GET_TASKOVERVIEW_SUCCESS = 'GET_TASKOVERVIEW_SUCCESS';
export const GET_TASKOVERVIEW_FAILURE = 'GET_TASKOVERVIEW_FAILURE';

export const GET_APPOINTMENTSTATUSSUMMARY_REQUEST = 'GET_APPOINTMENTSTATUSSUMMARY_REQUEST';
export const GET_APPOINTMENTSTATUSSUMMARY_SUCCESS = 'GET_APPOINTMENTSTATUSSUMMARY_SUCCESS';
export const GET_APPOINTMENTSTATUSSUMMARY_FAILURE = 'GET_APPOINTMENTSTATUSSUMMARY_FAILURE';

export const GET_TRANSACTIONS_REQUEST = 'GET_TRANSACTIONS_REQUEST';
export const GET_TRANSACTIONS_SUCCESS = 'GET_TRANSACTIONS_SUCCESS';
export const GET_TRANSACTIONS_FAILURE = 'GET_TRANSACTIONS_FAILURE';

export const GET_PENDINGTRANSACTIONS_REQUEST = 'GET_PENDINGTRANSACTIONS_REQUEST';
export const GET_PENDINGTRANSACTIONS_SUCCESS = 'GET_PENDINGTRANSACTIONS_SUCCESS';
export const GET_PENDINGTRANSACTIONS_FAILURE = 'GET_PENDINGTRANSACTIONS_FAILURE';

export const GET_AVGEARNINGANDFOLLOWUPRATE_REQUEST = 'GET_AVGEARNINGANDFOLLOWUPRATE_REQUEST';
export const GET_AVGEARNINGANDFOLLOWUPRATE_SUCCESS = 'GET_AVGEARNINGANDFOLLOWUPRATE_SUCCESS';
export const GET_AVGEARNINGANDFOLLOWUPRATE_FAILURE = 'GET_AVGEARNINGANDFOLLOWUPRATE_FAILURE';

export const POST_AVAILABILITY_REQUEST = 'POST_AVAILABILITY_REQUEST';
export const POST_AVAILABILITY_SUCCESS = 'POST_AVAILABILITY_SUCCESS';
export const POST_AVAILABILITY_FAILURE = 'POST_AVAILABILITY_FAILURE';

//GET BILLING_BY_ID
export const GET_BILLING_BY_ID_REQUEST = 'GET_BILLING_BY_ID_REQUEST';
export const GET_BILLING_BY_ID_SUCCESS = 'GET_BILLING_BY_ID_SUCCESS';
export const GET_BILLING_BY_ID_FAILURE = 'GET_BILLING_BY_ID_FAILURE';
//GET AVAILABLE_SLOTS
export const GET_AVAILABLE_SLOTS_REQUEST = 'GET_AVAILABLE_SLOTS_REQUEST';
export const GET_AVAILABLE_SLOTS_SUCCESS = 'GET_AVAILABLE_SLOTS_SUCCESS';
export const GET_AVAILABLE_SLOTS_FAILURE = 'GET_AVAILABLE_SLOTS_FAILURE';

// PATIENT LOOKUP
export const PATIENT_LOOKUP_REQUEST = 'PATIENT_LOOKUP_REQUEST';
export const PATIENT_LOOKUP_SUCCESS = 'PATIENT_LOOKUP_SUCCESS';
export const PATIENT_LOOKUP_FAILURE = 'PATIENT_LOOKUP_FAILURE';

// GET ALL DOCTORS
export const GET_ALL_DOCTORS_REQUEST = 'GET_ALL_DOCTORS_REQUEST';
export const GET_ALL_DOCTORS_SUCCESS = 'GET_ALL_DOCTORS_SUCCESS';
export const GET_ALL_DOCTORS_FAILURE = 'GET_ALL_DOCTORS_FAILURE';

